import {Badge} from '../../../../models/badge/badge';
import {AuthSupportState} from '../../../../../swagger-gen/web-secured/models/auth-support-state';
import {BadgeState} from '../../../../models/badge/badge-state';
import {BadgeProvider} from '../../../../models/badge/badge-provider';
import {BadgeType} from '../../../../models/badge/badge-type';
import {AuthSupportType} from '../../../../../swagger-gen/web-secured/models/auth-support-type';
import {AuthSupportsStateChange} from '../../../../../swagger-gen/web-secured/models/auth-supports-state-change';
import {AuthSupportCreate} from '../../../../../swagger-gen/web-secured/models/auth-support-create';
import {AuthSupportUpdate} from '../../../../../swagger-gen/web-secured/models/auth-support-update';

export class BadgeRepoDtoMapper {
    static toCreate(badge: Badge): AuthSupportCreate {
        return {
            value: badge.value,
            state: BadgeRepoDtoMapper.toState(badge.state),
            type: BadgeRepoDtoMapper.toType(badge.type),
            providers: [badge.provider],
            validityStart: badge.validityStart.toISOString(),
            validityEnd: badge.validityEnd.toISOString(),
            internalValue: badge.internalValue,
            reason: badge.reason,
            requestKM: badge.requestKM,
            secretCode: badge.secretCode,
            // subServiceUid: badge.service,
            // langCode: badge.langCode,
            // parcNumber: badge.parcNumber,
            // plateNumber: badge.plateNumber,
            // ceiling: badge.ceiling,
            // driverCode: badge.driverCode,
        };
    }

    static toUpdate(badge: Badge): AuthSupportUpdate {
        return BadgeRepoDtoMapper.toCreate(badge);
    }

    static toUpdateState(badgeIdList: string[], state: BadgeState): AuthSupportsStateChange {
        return {
            newState: BadgeRepoDtoMapper.toState(state),
            authSupportsUid: badgeIdList
        };
    }

    private static toState(badgeState: BadgeState): AuthSupportState {
        const stateMapping: Map<BadgeState, AuthSupportState> = new Map([
            [BadgeState.ACTIVE, AuthSupportState.ACTIVE],
            [BadgeState.RED_LIST, AuthSupportState.BLOCKED],
            [BadgeState.BLACK_LIST, AuthSupportState.REMOVED],
        ]);

        const state =  stateMapping.get(badgeState);
        if (!state) {
            throw new Error('Unkonwn state mapping');
        }

        return state;
    }

    private static toProvider(badgeProvider: BadgeProvider): any {
        const providerMapping: Map<BadgeProvider, any> = new Map([
            [BadgeProvider.LAFON, 'LAFON'],
            [BadgeProvider.GIR, 'GIR'],
            [BadgeProvider.GIR_LAFON, 'GIR_LAFON'],
            [BadgeProvider.GIR_GNV, 'GIR_GNV'],
            [BadgeProvider.SOGESMATIC, 'SOGESMATIC'],
            [BadgeProvider.OTHER, 'OTHER'],
        ]);

        const provider =  providerMapping.get(badgeProvider);
        if (!provider) {
            throw new Error('Unkonwn provider mapping');
        }

        return provider;
    }

    private static toType(badgeProvider: BadgeType): AuthSupportType {
        const typeMapping: Map<BadgeType, AuthSupportType> = new Map([
            [BadgeType.RFID, AuthSupportType.RFID],
            [BadgeType.QR_CODE, AuthSupportType.QR_CODE],
            [BadgeType.HID, AuthSupportType.HID],
            [BadgeType.LICENCE_PLATE, AuthSupportType.LICENCE_PLATE],
            [BadgeType.UNKNOWN, AuthSupportType.UNKNOWN],
        ]);

        const type =  typeMapping.get(badgeProvider);
        if (!type) {
            throw new Error('Unkonwn type mapping');
        }

        return type;
    }

}
